<template>
	<div id="app">
		<!-- Notification components -->
		<Alerts />
		<UploadAlerts />
		<InternetConnection />

		<!-- Routes -->
		<router-view />
	</div>
</template>

<script>
import '@/assets/scss/index.scss'
import '@/assets/scss/index.scss'
import 'clarks/styles/index.scss'
import 'notifications/styles/index.scss'
import notifications from 'notifications'

export default {
	name: "App",
	created(){
		
	},
	components: {
		...notifications.components,
		InternetConnection: () => import('wino-template/components/connection'),
	},
	data () {
		return {
			
		}
	},
	mounted(){
		this.$store.commit('router',this.$router)
		utils.printAppInfo()
	}
};
</script>

<style lang="scss">
@import 'wino-template/styles/index.scss';

:root {
   --primary: #{$primary};
   --secondary: #{$secondary};
}

#app {
	.row{
		margin: 0;
	}

	.app-loader{
		background: rgba(#fff,.95);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 7500;
		display: flex;
		justify-content: center;

		.logo{
			width: 100%;
			height: 100%;
			max-width: 200px;
			max-height: 200px;
		}

		.center-text{
			position: absolute;
			text-align: center;
			padding-top: calc(50vh - 150px) !important;
			color: var(--primary);

			.loading{
				height: 150px;
				width: auto;
			}
		}
		.txt{
			margin-top: 20px;
			font-size: 16px;
			font-weight: 600;
		}
	}
}
</style>
